import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Alert,
  Snackbar,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddIcon from "@mui/icons-material/Add";
import AddRoad from "./AddRoad";
import ViewRoad from "./ViewRoad";
import { get, api, del } from "../../../../utils/api";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterModal from "../../../../Components/Common/FilterModal";
import Cards from "./Cards";
import ViewTable from "../../../../Components/Common/ViewTable";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import uploadicon from "../../../../assets/images/uploadicon.svg";
import { useUser } from "../../../../context/AuthContext";
import ActionButtons from "../../../../Components/Common/ActionButtons";
import RoadBulkUpload from "./RoadBluckUpload";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";

const Road = () => {
  const { user } = useUser();
  const [petroleums, setPetroleums] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const [element, setElement] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [uniqueValues, setUniqueValues] = useState({});
  const [selectedFields, setSelectedFields] = useState({
    industrialProcess: [],
    equipmentType: [],
    industrialEquipment: [],
  });
  const [appliedFilters, setAppliedFilters] = useState({
    date: false,
    industrialProcess: false,
    equipmentType: false,
    industrialEquipment: false,
    quantityConsumed: false,
    hoursUsed: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [view, setView] = useState(false);
  const [dataView, setdataView] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [tableData, setTableData] = useState([]);
  // const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]); // Store selected countries
  const [selectedFacilities, setSelectedFacilities] = useState([]); // Store selected petroleum name
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [progresscards, setProgressCards] = useState({});
  const [totalcards, setTotalCards] = useState({});
  const [completecards, setCompleteCards] = useState({});
  const [cancelcards, setCancelCards] = useState({});
  const [pendingcards, setPendingCards] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    industrialProcess: false,
    equipmentType: false,
    industrialEquipment: false,
    quantityConsumed: false,
    hoursUsed: false,
  });
  const [filterSource, setFilterSource] = useState([]);
  const [filterDestination, setFilterDestitation] = useState([]);
  const [filterVehicle, setFilterVehicle] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterDriver, setFilterDriver] = useState([]);
  const [filterVendor, setFilterVendor] = useState([]);
  const [dataforView, setdataForView] = useState(null);

  const [excelData, setExcelData] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadTable, setBulkUploadTable] = useState(false);
  const [matchData, setMatchData] = useState([]);
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const [bulkuploadInputData, setBulkuploadInputData] = useState({});
  const [driverList, setDriverList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);

  const fetchExcelData = async () => {
    try {
      const res = await get(
        `/scope3/roadTransportation/generateRoadTransportionExcel`
      );
      const data = res.data.data;
      const arr = data.flatMap((el, idx) => [
        {
          "Trip Date (in DD/MM/YY)": "",
          "Transportation Type": "Upstream",
          Driver: el?.driver || "",
          Vendor: el?.vendor || "",
          Vehicle: el?.vehicle || "",
          Origin: "",
          Destination: "",
          "Remark (optional)": "",
        },
        {
          "Trip Date (in DD/MM/YY)": "",
          "Transportation Type": "Downstream",
          Driver: el?.driver || "",
          Vendor: el?.vendor || "",
          Vehicle: el?.vehicle || "",
          Origin: "",
          Destination: "",
          "Remark (optional)": "",
        },
      ]);

      setExcelData(arr);
    } catch (err) {
      console.log(err, "getting error");
    }
  };

  const DriverList = async () => {
    const response = await get(`/driver/master/getAll`);
    const data = response.data.data;
    setDriverList([...new Set(data.map((item) => item.driverName))]);
    return data;
  };

  const VendorList = async () => {
    const response = await get(`/master/logistic/vendorMaster`);
    const data = response.data.data;
    console.log(data, "data");

    setVendorList([
      ...new Set(data.map((item) => item.logisticVendorLegalName)),
    ]);
    return data;
  };

  const VehicleList = async () => {
    const response = await get(`/master/getAllVehicle`);
    const data = response.data.data;
    setVehicleList([...new Set(data.map((item) => item.vehicleNumber))]);
    return data;
  };

  useEffect(() => {
    DriverList();
    VendorList();
    VehicleList();
    fetchExcelData();
  }, []);

  const headers = [
    // { key: "consumptionPeriod", label: "Date", sortable: true },
    {
      key: "createdAt",
      label: "Date",
      sortable: true,
    },
    {
      key: "source",
      label: "Source",
      sortable: true,
    },
    {
      key: "destination",
      label: "Destination",
      sortable: true,
    },
    {
      key: "vehicle",
      label: "Vehicle",
      sortable: true,
    },
    {
      key: "vendor",
      label: "Vendor",
      sortable: true,
    },
    { key: "driver", label: "Driver", sortable: true },
    { key: "tripStatus", label: "Status", sortable: true },
  ];

  const inputData = [
    // {
    //   fieldName: "startDateAndTime",
    //   title: "Start Date And Time",
    //   placeholder: "MM/DD/YYYY",
    //   type: "date",
    // },
    {
      fieldName: "transportationType",
      title: "Transport Type",
      placeholder: "Tap to Select",
      type: "select",
      options: ["Upstream", "Downstream"],
      // url: `${api}/master/logistic/vendorMaster`,
      // field: "logisticVendorLegalName",
      required: true,
    },
    {
      fieldName: "dataEntryMode",
      title: "Data Entry Mode",
      type: "radio",
      paragraph: [
        "Manually input trip details.",
        "Automatically retrieve trip details from the linked application.",
      ],
      option: ["Enter manually", "Link to app"],
      keys: ["Manual", "App"],
      required: true,
    },
    {
      fieldName: "associatedVendor",
      title: "Vendor",
      placeholder: "Tap to Select",
      type: "select",
      url: `${api}/master/logistic/vendorMaster`,
      field: "logisticVendorLegalName",
      required: true,
    },
    {
      fieldName: "driver",
      title: "Driver",
      placeholder: "Tap to Select",
      // type: "select",
      url: `${api}/driver/master/getAll`,
      field: "driverName",
      // required: true,
    },
    {
      fieldName: "vehicle",
      title: "Vehicle",
      placeholder: "Tap to Select",
      // type: "select",
      // url: `${api}/master/getAllVehicle`,
      field: "vehicleNumber",
      required: true,
    },
    {
      fieldName: "brand",
      title: "Brand",
      placeholder: "Tap to Select",
      // type: "select",
      // url: `${api}/master/getAllVehicle`,
      // field: "vehicleNumber",
      required: true,
      disabled: true,
    },
    {
      fieldName: "model",
      title: "Model",
      placeholder: "Tap to Select",
      // type: "select",
      // url: `${api}/master/getAllVehicle`,
      // field: "vehicleNumber",
      required: true,
      disabled: true,
    },
    {
      fieldName: "tripDate",
      title: "Trip start date",
      placeholder: "Type",
      type: "date",
    },
    {
      fieldName: "source",
      title: "Source",
      queryType: "city",
      placeholder: "Type",
      type: "LocationAutocomplete",
    },
    {
      fieldName: "destination",
      title: "Destination",
      queryType: "city",
      placeholder: "Type",
      type: "LocationAutocomplete",
    },
    {
      fieldName: "declaredEfficiency",
      title: "Declared Efficiency",
      placeholder: "Declared Efficiency",
      // type: "number",
    },
    {
      fieldName: "distanceTravel",
      title: "Distance Travelled",
      placeholder: "Autofetched",
      //  type: "number",
      required: true,
    },
    {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      // type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope3/roadTransportation/get`);
      const data = response.data.data;

      const uniqueEquipmentType = [
        ...new Set(
          data.map((el) => el.equipment?.equipment).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueIndustrialEquipment = [
        ...new Set(
          data.map((el) => el?.currentMeterReading).filter(Boolean) // Filter out undefined values
        ),
      ];
      // const uniqueUnit = [
      //   ...new Set(
      //     data.map((el) => el?.unitOfConsumption).filter(Boolean) // Filter out undefined values
      //   ),
      // ];

      return {
        equipment: uniqueEquipmentType,
        currentMeterReading: uniqueIndustrialEquipment,
        // unitOfConsumption:uniqueUnit
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const handleMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    // setSelectedPetroleum(petroleum);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedPetroleum(null);
  };

  const handleEdit = (data) => {
    handleMenuClose();
    setAddData(true);
    setView(false);
    setdataView(data?._id !== undefined ? data : data?.data);
  };

  const handleView = (data) => {
    handleMenuClose();
    setView(true);
    setAddData(false);
    setdataForView(data?.data);
  };

  const handleDelete = (index) => {
    handleMenuClose();
    setDeleteDialog(true);
    setdataView(index.id);
  };

  const handleDeleteAggree = async () => {
    await del(`/scope3/roadTransportation/delete`, {
      params: {
        Id: dataView, // Pass as query parameter
      },
    })
      .then(async (res) => {
        setDeleteDialog(false);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        //  if (currentPage > 1 && tableData?.length === 1) {
        //   setCurrentPage(currentPage - 1);
        // }
        fetchData();
      })
      .catch((err) => {
        setsnackOpen({
          open: true,
          message: err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // fetching petroleum data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    // const fetchData = async (filters = {}) => {
    let filter = { ...filterObj };
    if (
      filter.declaredEfficiency &&
      // filter.minEfficiency &&
      // filter.maxEfficiency
      filter.declaredEfficiency.min &&
      filter.declaredEfficiency.max
    ) {
      filter.minEfficiency = parseInt(filterObj.declaredEfficiency.min);
      filter.maxEfficiency = parseInt(filterObj.declaredEfficiency.max);
    }

    if (filter.createdAt?.start) {
      filter.startDate = filter.createdAt.start;
    }
    if (filter.createdAt?.end) {
      filter.endDate = filter.createdAt.end;
    }
    if (filter.dateTime?.start) {
      filter.TipStart = filter.dateTime.start;
    }
    if (filter.dateTime?.end) {
      filter.TripEnd = filter.dateTime.end;
      delete filter.dateTime;
    }
    try {
      const queryParams = new URLSearchParams({
        ...filter,
        page: currentPage,
        limit: 10,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(
        `/scope3/roadTransportation/get?${queryParams}`
      );
      let arr = response?.data?.data?.map((item) => {
        return {
          createdAt: new Date(item.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
          distanceTravel: item?.distanceTravel?.value,
          vendor: item?.associatedVendor?.logisticVendorLegalName,
          driver: item.driver?.driverName,
          fuelType: item.fuelType,
          vehicle: item.vehicle?.vehicleNumber,
          source: item.source,
          destination: item.destination,
          tripStatus: item?.tripStatus,
          action: "View",
          id: item?._id,
          data: item,
        };
      });
      setTableData(arr);
      setPetroleums(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      setPageSize(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage, sortConfig, filterObj]);

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);
  const resetDataView = () => setdataView(null);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [tableData]);

  const fetchCardData = async () => {
    try {
      const res = await get(`/scope3/roadTransportation/cardData`);

      res?.data?.data.forEach((item) => {
        if (item?.status === "Pending") {
          setPendingCards({
            status: item.status,
            upstreamCount: item.upstreamCount,
            downstreamCount: item.downstreamCount,
          });
        } else if (item?.status === "Completed") {
          setCompleteCards({
            status: item.status,
            upstreamCount: item.upstreamCount,
            downstreamCount: item.downstreamCount,
          });
        } else if (item?.status === "Cancelled") {
          setCancelCards({
            status: item.status,
            upstreamCount: item.upstreamCount,
            downstreamCount: item.downstreamCount,
          });
        } else if (item?.status === "In Progress") {
          setProgressCards({
            status: item.status,
            upstreamCount: item.upstreamCount,
            downstreamCount: item.downstreamCount,
          });
        } else if (item?.status === "Total") {
          setTotalCards({
            status: item.status,
            upstreamCount: item.upstreamCount,
            downstreamCount: item.downstreamCount,
          });
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, [tableData]);

  // default filters to apply
  const filtersToApply = {
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    //  TipStart:TipStart? TipStart.format("YYYY-MM-DD"):"",
    //  TripEnd:TripEnd? TripEnd.format("YYYY-MM-DD"):"",
    ...Object.keys(selectedFields).reduce((acc, key) => {
      const selectedOptions = selectedFields[key];

      // Check if there are selected options
      if (selectedOptions && selectedOptions.length > 0) {
        // Join options into a string or keep them as an array
        acc[key] = selectedOptions.join(","); // Change to an array if needed
      }
      return acc;
    }, {}),
  };

  const openModal = (type, dataForEdit = null) => {
    if (type === "add") {
      setEditModal(false);
      setEditData(null);
      setAddData(true);
    } else if (type === "edit") {
      setAddData(false);
      setEditModal(true);
      setEditData(dataForEdit);
    }
  };
  // Applying selected filter
  // useEffect(() => {
  //   fetchData();
  // }, [sortConfig, filterObj]);

  const fetchFilters = async () => {
    await get(`/scope3/roadTransportation/road/filter`)
      .then((res) => {
        setFilterDestitation(res?.data?.data?.destination);
        setFilterSource(res?.data?.data?.source);
        setFilterStatus(res?.data?.data?.status);
        setFilterVehicle(
          res?.data?.data?.vehicles.map((vehicle) => vehicle?.vehicleNumber)
        );
        setFilterVendor(res?.data?.data?.vendor.map((vendor) => vendor?.name));
        setFilterDriver(res?.data?.data?.driver.map((driver) => driver?.name));
        // setFilterVehicle(res?.data?.data?.vehicles.filter(vehicle => vehicle?.vehicleType !== vehicle?.vehicleType));
        // setFilterDestination(res?.data?.data?.destination);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    { title: "Status", type: "option", key: "status", value: filterStatus },
    {
      title: "Trip Date",
      type: "date",
      key: "dateTime",
      value: [],
    },
    {
      title: "Source",
      type: "option",
      key: "source",
      value: filterSource,
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: filterDestination,
    },
    {
      title: "Vehicle",
      type: "option",
      key: "vehicle",
      value: filterVehicle,
    },
    {
      title: "Vendor",
      type: "option",
      key: "vendor",
      value: filterVendor,
    },
    {
      title: "Driver",
      type: "option",
      key: "driver",
      value: filterDriver,
    },
    // {
    //   title: "Declared Efficiency",
    //   type: "limit",
    //   key: "declaredEfficiency",
    //   // value: ["one", "two"],
    //   placeholderMin: "min",
    //   placeholderMax: "max",
    // },
  ];

  const handleFilterChange = (newFilterObj) => {
    setCurrentPage(1);
    setFilterObj(newFilterObj);
    setPage(1);

    console.log("Applied Filters:", newFilterObj);
  };
  // Handle Sorting function
  const handleSort = (column, direction) => {
    if (column === "status") {
      setSortConfig({ key: "tripStatus", direction });
    } else {
      setSortConfig({ key: column, direction });
    }
  };

  let bannerData = [
    {
      title: "All Trips",
      description: [
        { Upstream: totalcards?.upstreamCount },
        { Downstream: totalcards?.downstreamCount },
      ],
    },
    {
      title: "Completed Trips",
      description: [
        { Upstream: completecards?.upstreamCount },
        { Downstream: completecards?.downstreamCount },
      ],
    },
    {
      title: "Yet to start",
      description: [
        { Upstream: pendingcards?.upstreamCount },
        { Downstream: pendingcards?.downstreamCount },
      ],
    },
    {
      title: "In Progress",
      description: [
        { Upstream: progresscards?.upstreamCount },
        { Downstream: progresscards?.downstreamCount },
      ],
    },
    {
      title: "Cancelled",
      description: [
        { Upstream: cancelcards?.upstreamCount },
        { Downstream: cancelcards?.downstreamCount },
      ],
    },
  ];
  const closeAddDrawer = () => {
    setAddData(false);
    resetDataView();
  };

  const closeViewDrawer = () => {
    setView(false);
    resetDataView();
  };

  return (
    <Box
      sx={{
        backgroundColor: "#ededed",
      }}
    >
      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>

      <AddRoad
        addData={addData}
        setAddData={setAddData}
        id={dataView ? dataView._id : ""}
        SelectedData={dataView}
        fetchData={fetchData}
        inputData={inputData}
        addUrl={`${api}/scope3/roadTransportation/add`}
        updateUrl={`${api}/scope3/roadTransportation/update`}
        setsnackOpen={setsnackOpen}
        // onClose={() => setAddData(false)}
        onClose={closeAddDrawer}
        resetSelectedData={resetDataView}
      />
      <ViewRoad
        // view={view}
        // setView={setView}
        // selectedData={dataforView}
        id={element ? element._id : ""}
        data={dataforView}
        title={"Trip"}
        viewData={view}
        setViewData={setView}
        inputData={inputData}
        handleEdit={handleEdit}
        companyAdmin={user?.companyAdmin}
      />
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />
      {/* <Box sx={{ margin: "0% 13% -3% 3%" }}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: 2,
            margin: "5% 55% 0% 22%",
          }}
        ></Box>
      </Box> */}
      <Cards data={bannerData} flexwrap="no" title={"Trips"} />

      {/* {deleteDialog && (
        <Dialog open={deleteDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this entry?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteAggree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
      {deleteDialog && (
        <DeleteAlertDialog
          {...{
            deleteDialog,
            setDeleteDialog,
            method: "delete",
            id: dataView,
            url: `${api}/scope3/roadTransportation/delete`,
            setsnackOpen,
            fetchData,
            fetchCardData,
          }}
        />
      )}

      <ActionButtons
        onFilterClick={() => setIsFilterModalOpen(true)}
        onAddClick={() => openModal("add")}
        onUploadClick={() => setBulkUploadModal(true)}
        filterObj={filterObj}
      />

      <ViewTable
        headers={headers}
        title={"Trips"}
        data={tableData}
        onSort={handleSort}
        sortConfig={sortConfig}
        onMenuClick={handleMenuClick}
        totalPages={totalPages}
        page={currentPage}
        count={pageSize}
        editIcon={user?.companyAdmin ? "disable" : "enable"}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        // onPageChange={handlePageChange}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        tableContainerRef={tableContainerRef}
        isShortContent={isShortContent}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "120px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        <MenuItem onClick={handleView} sx={{ fontSize: "14px" }}>
          <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} /> View
          Logs
        </MenuItem>
        {user?.companyAdmin ? null : (
          <>
            <MenuItem onClick={handleEdit} sx={{ fontSize: "14px" }}>
              <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
            </MenuItem>

            <MenuItem onClick={handleDelete} sx={{ fontSize: "14px" }}>
              <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
              Delete
            </MenuItem>
          </>
        )}
      </Menu>

      {bulkUploadModal && (
        <BulkUploadModal
          onCloseBulkUpload={() => {
            setBulkUploadModal(false);
            fetchData();
          }}
          {...{
            setMatchData,
            formDataBulkUpload,
            setFormDataBulkUpload,
          }}
          errorClose={() => setBulkUploadTable(true)}
          setsnackOpen={setsnackOpen}
          setBulkUploadModal={setBulkUploadModal}
          matchedKey="statusList"
          isBulkUploadModal={bulkUploadModal}
          excelData={excelData}
          fileName={"Road Transportation"}
          url={"/scope3/roadTransportation/bulkUploadRoadTransportion"}
        />
      )}
      {bulkUploadTable && (
        <RoadBulkUpload
          matchData={matchData}
          setMatchData={setMatchData}
          onClose={() => setBulkUploadTable(false)}
          bulkUploadTable={bulkUploadTable}
          {...{ formDataBulkUpload, setFormDataBulkUpload }}
          addNew={false}
          title1="Driver"
          keyValue1="driver"
          options1={driverList}
          matched1={"driverMatched"}
          title2="Vendor"
          keyValue2="vendor"
          options2={vendorList}
          matched2={"vendorMatched"}
          title3="Vehicle"
          keyValue3="vehicle"
          options3={vehicleList}
          matched3={"vehicleMatched"}
          bulkUploadUrl={"/scope3/roadTransportation/jsonupload"}
          setsnackOpen={setsnackOpen}
          onConfirm={() => {
            setBulkUploadTable(true);
            fetchData();
          }}
        />
      )}
    </Box>
  );
};

export default Road;
